package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class BulkUploadResponse(
    @SerialName("success")
    val success: Boolean? = null,
    @SerialName("message")
    val message: String? = null,
    @SerialName("staff_created")
    val staffCreated: Int? = null,
    @SerialName("staff_failed")
    val staffFailed: Int? = null,
    @SerialName("staff_errors")
    val staffErrors: List<String>? = null,
    @SerialName("subjects_created")
    val subjectsCreated: Int? = null,
    @SerialName("subjects_failed")
    val subjectsFailed: Int? = null,
    @SerialName("subjects_errors")
    val subjectsErrors: List<String>? = null,
    @SerialName("classes_created")
    val classesCreated: Int? = null,
    @SerialName("classes_failed")
    val classesFailed: Int? = null,
    @SerialName("classes_errors")
    val classesErrors: List<String>? = null,
    @SerialName("allocations_created")
    val allocationsCreated: Int? = null,
    @SerialName("allocations_failed")
    val allocationsFailed: Int? = null,
    @SerialName("allocations_errors")
    val allocationsErrors: List<String>? = null,
    @SerialName("details_url")
    val detailsUrl: String? = null
)

@Serializable
data class BulkUploadValidationResponse(
    @SerialName("message")
    val message: String? = null,
    @SerialName("validation_errors")
    val validationErrors: List<String>? = null
)

@Serializable
data class StudentEnrollmentValidationResponse(
    @SerialName("message")
    val message: String? = null,
    @SerialName("validation_errors")
    val validationErrors: List<String>? = null
)
